import { useState, useCallback } from 'react';

export const useToggle = (initialValue = false) => {
  const [toggle, setToggle] = useState(initialValue);

  const handleToggle = useCallback((nextValue) => {
    setToggle((prevToogle) =>
      typeof nextValue === 'boolean' ? nextValue : !prevToogle,
    );
  }, []);

  return [toggle, handleToggle];
};
